// extracted by mini-css-extract-plugin
export default {"container":"BJ-z","timeTop":"CJ-z","timeCountdown":"DJ-z","cta":"EJ-z","disabled":"FJ-z","product":"GJ-z"};